let prevScrollpos = 0;
let up = false;

function repeatOften() {
  const navbar = document.getElementById('navbar');
  const currentScrollPos = window.scrollY;

  if (!navbar) {
    return;
  }

  if ((prevScrollpos >= currentScrollPos && up) || prevScrollpos === 0) {
    navbar.classList.remove('navbar--hidden');
    if (prevScrollpos >= currentScrollPos && up) {
      navbar.classList.add('navbar--sticky');
    }
    if (prevScrollpos === 0) {
      navbar.classList.remove('navbar--sticky');
    }
  } else {
    if (!navbar.classList.contains('navbar--open') && currentScrollPos > 103) {
      navbar.classList.add('navbar--hidden');
    }
  }

  if (prevScrollpos > currentScrollPos) {
    up = true;
  }
  if (prevScrollpos < currentScrollPos || prevScrollpos === 0) {
    up = false;
  }

  prevScrollpos = currentScrollPos > 0 ? currentScrollPos : 0;

  requestAnimationFrame(repeatOften);
}
requestAnimationFrame(repeatOften);
